import type { SVGProps } from 'react';
import { useFela } from 'react-fela';

import type { Theme } from '@/styles/theme';

export interface PasskeyProps extends SVGProps<SVGSVGElement> {}

export const Passkey = (props: PasskeyProps) => {
    const { theme } = useFela<Theme>();

    return (
        <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                d='M8.99707 7.65C8.63903 7.65 8.29565 7.79223 8.04248 8.04541C7.7893 8.29858 7.64707 8.64196 7.64707 9C7.64707 9.6885 7.57957 10.6942 7.47157 11.7M10.3471 9.756C10.3471 11.3625 10.3471 14.0625 9.67207 15.75M12.5678 15.0885C12.6488 14.6835 12.8581 13.536 12.9053 13.05M2.24707 9C2.24707 7.58329 2.69282 6.2025 3.52119 5.05321C4.34955 3.90391 5.51853 3.04439 6.86253 2.59639C8.20654 2.14839 9.65743 2.13462 11.0097 2.55703C12.362 2.97945 13.547 3.81663 14.3971 4.95M2.24707 11.7H2.25382M15.6121 11.7C15.7471 10.35 15.7005 8.08605 15.6121 7.65M4.272 14.0625C4.6095 13.05 4.947 11.025 4.947 8.99996C4.94632 8.5402 5.02393 8.08367 5.1765 7.64996M6.73575 15.75C6.8775 15.3045 7.0395 14.859 7.1205 14.4M6.972 5.48996C7.58787 5.13439 8.28651 4.94725 8.99765 4.94736C9.7088 4.94748 10.4074 5.13484 11.0231 5.49061C11.6389 5.84638 12.1501 6.35801 12.5054 6.97405C12.8607 7.59009 13.0475 8.28882 13.047 8.99996V10.35'
                stroke={theme.colors.secretType.passkey}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};
